module.exports = __webpack_public_path__ + "static/chevron-right.406db43d.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/chevron-right.png
// module id = 539
// module chunks = 1